import React, { useState } from 'react'
import Loader from '../../Components/Loader'
import SubHeader from '../../Components/Customer/SubHeader';
import Header from '../../Components/Customer/Header';
import Login from '../../Components/Customer/Login';
import useToken from '../../Components/Customer/useToken';
import useAccount from '../../Components/Customer/useAccount';
import { useNavigate } from "react-router-dom";
function Home(props) {
  let navigate = useNavigate();

  // const query = new URLSearchParams(window.location.search);
  const [serviceType, setServiceType] = useState(props.service_type ? props.service_type : 'ac-qd');
  const { account, setAccount } = useAccount();
  const { token, setToken } = useToken();
  
 


  if (!token || !account) {
    return <Login setToken={setToken} setAccount={setAccount} />
  }
  const logout = () => {
    setToken('')
    setAccount('')
   sessionStorage.removeItem("token");
   sessionStorage.removeItem("account_details");
}
const accountServices =
  account?.existing_services?.[account?.primary_property_id] || [];
const qualifiesForACQD = ['sanihome', 'sanicorp', 'ac-qd']
  .some(k => accountServices.includes(k));
console.log('qualifiesForACQD', accountServices);
  return (

    <div className="">

      <Header clickLogout={logout}
        serviceType={null} 
        globalServiceTypes={props.globalServiceTypes}
        setServiceType={setServiceType}
        account={account}
        />

      <SubHeader account={account}
        serviceType={null}
        key={account.primary_property_id} />

    

      {/* Begin */}
      <section id="header-section"
        className=" bg-slate sm:max-w-full">
        {/* Xl Screen Begin */}
        <div className="bg-cover bg-[url('../public/img/home-banner.jpg')]  w-full flex items-center">

          <div className="container mx-auto  my-40  px-4">
            <div className='text-left  leading-tight text-white
          lg:text-5xl text-4xl
           font-medium tracking-normal'>
              Book Now for a<br />
              Healthier Indoor Space
            </div>
            <div className='text-left   max-w-md leading-normal text-white
        pt-5
            lg:text-lg text-base
           font-normal tracking-normal'>
              Easily schedule expert services that improve your indoor environment — fast, simple, and hassle-free.
            </div>
            <div className='text-left mt-9'>

              <a href="https://saniservice.com/"
                target="_blank"
                className="text-white text-sm hover:text-danger hover:border-danger border-b font-normal">Learn More</a>


            </div>
          </div>
        </div>
        {/* Xl Screen End */}

      </section>
      {/* End */}


        {/* Begin */}
        <section id="header-section"
        className=" bg-slate sm:max-w-full">
        {/* Xl Screen Begin */}
        <div className=" w-full flex items-center">

          <div className="container mx-auto  my-14  px-4">
            <div className='text-center  leading-tight 
          lg:text-5xl text-4xl
           font-medium tracking-normal'>
            Select a Service, Book with Ease
            </div>
            <div className='text-center   leading-normal 
        pt-5
            lg:text-lg text-base
           font-normal tracking-normal'>
             Choose the service you need and schedule your appointment in just a few clicks
            </div>
         
          </div>
        </div>
        {/* Xl Screen End */}

      </section>
      {/* End */}

    {/* Begin */}
    {props.globalServiceTypes
  .filter(s => s.type && s.type.includes('service')) // only show service type
  .filter(s => account.existing_services?.[account.primary_property_id]?.includes(s.key)) // only show existing services
  .map(service => (
  //  console.log(service)
    <section  key={service.key}
    id="header-section"
        className=" bg-slate  mb-14 sm:max-w-full">
        {/* Xl Screen Begin */}
        <div 
        className="bg-cover box-shadow-banner bg-center  w-full flex items-center"
        style={{ backgroundImage: `url(/img/${service.image_url})` }}
        >

          <div className="container mx-auto  my-40  px-4">
            <div className='text-left  leading-tight 
          lg:text-5xl text-4xl 
           font-medium tracking-normal'>
            {service.label}
            </div>
            <div className='text-left  max-w-xl leading-normal 
        pt-5 pb-5
           text-base text-primary/70
           font-normal tracking-normal'>
            {service.description}
            </div>
            <div className='text-left mt-3 gap-2 flex'>

              <a href={service.read_more_link}
                target="_blank"
                className=" text-sm hover:text-danger hover:border-danger mr-3  ml-0 border-primary px-4 py-2 rounded border font-normal">Learn More</a>
  <a href="javascript:void(0)"
             onClick={() => navigate(
  account.existing_services?.[account.primary_property_id]?.includes(service.key)
    ? `/${service.key}`
    : `/inspection/${service.key}` 
)}
                className=" text-sm  mx-4  border border-danger px-4 py-2
                 text-white rounded bg-danger font-normal">
                  {account.existing_services?.[account.primary_property_id]?.includes(service.key) ? "Book Service Now" : "Book Your Inspection"}
                  </a>


            </div>
          </div>
        </div>
        {/* Xl Screen End */}

      </section>
  ))}
      {/* End */}

  







    </div>

  )
}

export default Home